import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { DIRECTIONS } from 'react-with-direction/dist/DirectionProvider';
import { LanguageContext } from '../../types';

const initialLanguageContext = {
  direction: DIRECTIONS.LTR,
  language: 'en',
};

interface GeneralState {
  errorQueue: Array<{
    errorStatus: number;
    errorText: string | string[];
    errorTitle: string | string[];
  }>;
}

const initialState = {
  languageContext: initialLanguageContext as LanguageContext,
  categoriesColors: {},
  currencyRates: undefined,
  allCurrencyRates: undefined,
  gqlClient: undefined,
  token: undefined,
  dashboardVerseion: undefined,
  serviceVersion: undefined,
  isMenuOpen: false,
  errorQueue: [],
  unauthorizedError: false,
};

const general = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setSelectedLanguage(state, { payload }: PayloadAction<LanguageContext>) {
      //set the moment locale to the selected language
      //This will change the text of the moment.js library to the selected language
      moment.locale(payload.language === 'heb' ? 'he' : 'en-gb');
      state['languageContext'] = payload;
    },
    setCategoriesColors(state, { payload }: PayloadAction<any>) {
      state['categoriesColors'] = payload;
    },
    setCurrencyRates(state, { payload }: PayloadAction<any>) {
      state['currencyRates'] = payload;
    },
    setAllCurrencyRates(state, { payload }: PayloadAction<any>) {
      state['allCurrencyRates'] = payload;
    },

    setToken(state, { payload }: PayloadAction<any>) {
      state['token'] = payload;
    },
    setGqlClient(state, { payload }: PayloadAction<any>) {
      state['gqlClient'] = payload;
    },
    setDashboardVersion(state, { payload }: PayloadAction<any>) {
      state['dashboardVerseion'] = payload;
    },
    setServiceVersion(state, { payload }: PayloadAction<any>) {
      state['serviceVersion'] = payload;
    },
    setIsMenuOpen(state, { payload }: PayloadAction<boolean>) {
      state['isMenuOpen'] = payload;
    },
    addErrorToQueue: (
      state,
      action: PayloadAction<{
        errorStatus: number;
        errorText: string | string[];
        errorTitle: string | string[];
      }>,
    ) => {
      state.errorQueue.push(action.payload);
    },
    removeAllErrorsQueue: state => {
      state.errorQueue = [];
    },
    setUnauthorizedError: (state, action: PayloadAction<boolean>) => {
      state.unauthorizedError = action.payload;
    },
  },
});

export const {
  setSelectedLanguage,
  setCategoriesColors,
  setCurrencyRates,
  setAllCurrencyRates,
  setToken,
  setGqlClient,
  setDashboardVersion,
  setServiceVersion,
  setIsMenuOpen,
  addErrorToQueue,
  removeAllErrorsQueue,
  setUnauthorizedError,
} = general.actions;

export default general.reducer;
